import { useSearchParams } from 'react-router-dom';

export const useReturnToApp = () => {
  const [searchParams] = useSearchParams();
  const pathname = searchParams.get('pathname');

  return {
    pushReturn: (callBackUrl: string) => {
      if (!callBackUrl) {
        alert("it hasn't callbackUrl");
        return;
      }
      // if (window.api?.APP_ENV === 'development') {
      //   window.location.href =
      //     callBackUrl +
      //     '/connect/authorize' +
      //     '?client_id=' +
      //     token +
      //     (!!pathname ? '&pathname=' + (pathname.replace(/^(\/)*/g, '/')) : '');
      //   return;
      // }
      window.location.href =
        callBackUrl + (!!pathname ? '/' + pathname.replace(/^\//, '') : '');

      console.log("urlll",callBackUrl + (!!pathname ? '/' + pathname.replace(/^\//, '') : ''))
    },
  };
};
